export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-en-95056282d32d48dea98e34a5143bc621.png";